"use strict";

require("core-js/modules/es6.object.define-property");

var _styledComponents = _interopRequireDefault(require("styled-components"));

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.AccordionBody = exports.AccordionHead = exports.AccordionSection = exports.Accordion = void 0;

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    "default": a
  };
}

var Accordion = _styledComponents["default"].div.withConfig({
  displayName: "styles__Accordion"
})([""]);

exports.Accordion = Accordion;

var AccordionSection = _styledComponents["default"].div.withConfig({
  displayName: "styles__AccordionSection"
})(["background-color:#e1e9ef;margin-bottom:", ";"], function (a) {
  return a.isLast ? "0" : "2em";
});

exports.AccordionSection = AccordionSection;

var AccordionHead = _styledComponents["default"].div.withConfig({
  displayName: "styles__AccordionHead"
})(["cursor:pointer;color:#003b66;font-size:16;font-weight:600;font-family:'Open Sans';padding:1em 1.25em 1em 1.25em;"]);

exports.AccordionHead = AccordionHead;

var AccordionBody = _styledComponents["default"].div.withConfig({
  displayName: "styles__AccordionBody"
})(["background-color:#f0f4f7;padding:1em 1.25em 1em 1.25em;"]);

exports.AccordionBody = AccordionBody;